'use client'
import React, { useEffect } from 'react';

interface ContentComponentProps extends React.HTMLAttributes<HTMLDivElement> {
    offset?: number;
}

const BlogTableManager: React.FC<ContentComponentProps> = ({ offset = 50, ...rest }) => {
    useEffect(() => {
        const handleAnchorClick = (event: MouseEvent) => {
            event.preventDefault();
            
            const target = event.currentTarget as HTMLAnchorElement;
            const targetId = target.getAttribute('href')?.substring(1);
            const targetElement = targetId ? document.getElementById(targetId) : null;

            if (targetElement) {
                const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth',
                });
            }
        };

        const anchors: any = document.querySelectorAll('#rank-math-toc nav div a');
        anchors.forEach((anchor: any) => {
            anchor.addEventListener('click', handleAnchorClick);
        });

        

        return () => {
            anchors.forEach((anchor: any) => {
                anchor.removeEventListener('click', handleAnchorClick);
            });
        };
    }, [offset]);

    return (
        <div  {...rest} />
    );
};

export default BlogTableManager;
